import React from 'react';
import PropTypes from 'prop-types';
import PinnedPosts from './communityHomePinnedPosts';
import AboutUs from './communityHomeAboutUs';
import Events from './communityHomeEvents';
import PromoImage from './communityHomePromoImage';
import SupportUs from './communityHomeSupportUs';
import LatestPoll from 'src/modules/community/shared/components/sidebar/communityLatestPoll';

const CommunityHomeWidgets = ({ widgets, community }) => (
  <div className="community__widgets">
    {widgets.map(widget => {
      switch (widget.widgetType) {
        case 'Events':
          return (
            <Events
              events={widget.events}
              key="widget-events"
            />
          );
        case 'ContactUs':
          return (
            <AboutUs
              community={community}
              key="widget-aboutUs"
              widget={widget}
            />
          );
        case 'PinnedPosts':
          if (!widget.posts || widget.posts.length === 0) {
            return null;
          }
          return (
            <PinnedPosts
              community={community}
              key="widget-pinnedPosts"
              posts={widget.posts}
            />
          );
        case 'Campaign':
          return (
            <PromoImage
              key="widget-promoImage"
              widget={widget}
            />
          );
        case 'SupportUs':
          return (
            <SupportUs
              key="widget-supportUs"
              widget={widget}
            />
          );
        case 'LatestPoll':
          return (
            <LatestPoll
              community={community}
              key="widget-latestPoll"
              widget={widget}
            />
          );
        default:
          return null;
      }
    })}
  </div>
);

CommunityHomeWidgets.propTypes = {
  community: PropTypes.object,
  widgets: PropTypes.array,
};

CommunityHomeWidgets.defaultProps = {
  community: {},
  widgets: [],
};

export default CommunityHomeWidgets;
